import { render, staticRenderFns } from "./llfx.vue?vue&type=template&id=9b38ef1e&scoped=true&"
import script from "./llfx.vue?vue&type=script&lang=js&"
export * from "./llfx.vue?vue&type=script&lang=js&"
import style0 from "./llfx.vue?vue&type=style&index=0&id=9b38ef1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b38ef1e",
  null
  
)

export default component.exports